import baseUrl from './baseUrl';

const URL_FORGOT = `${baseUrl}/forgot`;

const forgotPassword = async data => {
  try {
    const res = await fetch(URL_FORGOT, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      if (res?.status === 403) {
        return { "error": "Erro no reCAPTCHA" };
      }

      return { "error": "e-mail não encontrado" };
    }

    const response = await res.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default forgotPassword;
